import {AbstractControl, ValidatorFn} from '@angular/forms';

export function positiveNumberValidator(zero = true): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        return control.value < 0 || (!zero && control.value <= 0) ? {'positiveNumber': {value: control.value}} : null;
    };
}


// WEBPACK FOOTER //
// /app/src/validators/positiveNumber.validator.ts